import { useState } from "react";
import {
  PayPalScriptProvider,
  PayPalButtons,
  FUNDING,
} from "@paypal/react-paypal-js";
import {
  setRazorpayModalError,
  setShowCancellationScreen,
} from "../../redux/otherDetailsSlice";
import { useDispatch } from "react-redux";
import { setShowPayPalModal } from "../../redux/addOnSlice";
import { createPaymentOrder } from "../../redux/razorPaySlice";
import { X } from "lucide-react";

// Sample product data
const product = {
  name: "Digital Product",
  price: 19.99,
  description: "Premium Digital Content",
};

export default function PayPalCheckout({
  getOrderStatusFailed,
  getOrderStatusSuccess,
  discountPrice,
  getSelectedItems,
  utmSource,
  scholarshipType,
  handleClose,
  originalPrice,
  getSelectedProducts,
}) {
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [message, setMessage] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [transactionDetails, setTransactionDetails] = useState(null);
  const dispatch = useDispatch();
  const [clickedState , setClickedState] = useState(false);

  // Reset payment status when user wants to try again
  const resetPayment = () => {
    setPaymentStatus(null);
    setMessage("");
    setTransactionDetails(null);
  };

  const products = getSelectedProducts();

  async function handleCreateOrder() {
    setIsProcessing(true);
    try {
      const response = await dispatch(
        createPaymentOrder({
          items: getSelectedItems(),
          utm_source: utmSource,
          scholarship_type: scholarshipType,
        })
      ).unwrap();
      // const response = await fetch("https://certified-new.learntube.ai/create_v2_test_global", {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   // use the "body" param to optionally pass additional order information
      //   // like product ids and quantities
      //   body: JSON.stringify({
      //     cart: [
      //       {
      //         id: 45,
      //         quantity: 1000,
      //       },
      //     ],
      //   }),
      // });

      const orderData = {
        ...response,
        order_cost: response?.order_cost / 100,
      };
      console.log("response", orderData);
      console.log("result", orderData);
      setIsProcessing(false);

      if (orderData?.razorpay_order_id) {
        return orderData?.razorpay_order_id;
      } else {
        const errorDetail = orderData?.details?.[0];
        const errorMessage = errorDetail
          ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
          : JSON.stringify(orderData);

        dispatch(setRazorpayModalError("network_issue"));
        //dispatch(setShowCancellationScreen(true))
      }
    } catch (error) {
      console.error(error);
      setIsProcessing(false);
      setMessage(`Could not initiate PayPal Checkout...${error}`);
      dispatch(setRazorpayModalError("network_issue"));
      //dispatch(setShowCancellationScreen(true))
    }
  }

  async function handleOnApprove(data, actions) {
    setIsProcessing(true);
    setMessage("Processing payment...");

    try {
      const response = await fetch(
        `https://certified-new.learntube.ai/api/orders/capture`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            order_id: data.orderID,
          }),
        }
      );

      let orderDataBody = await response.json();
      const orderData = orderDataBody?.data?.details;
      console.log("order", orderDataBody);
      // Three cases to handle:
      //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
      //   (2) Other non-recoverable errors -> Show a failure message
      //   (3) Successful transaction -> Show confirmation or thank you message

      const errorDetail = orderData?.details?.[0];

      if (errorDetail?.issue === "INSTRUMENT_DECLINED") {
        // (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
        // recoverable state, per https://developer.paypal.com/docs/checkout/standard/customize/handle-funding-failures/
        setIsProcessing(false);
        dispatch(setRazorpayModalError("insufficient_funds"));
        //dispatch(setShowCancellationScreen(true))
      } else if (errorDetail) {
        // (2) Other non-recoverable errors -> Show a failure message
        setIsProcessing(false);
        setPaymentStatus("error");
        throw new Error(`${errorDetail.description} (${orderData.debug_id})`);
      } else {
        // (3) Successful transaction -> Show confirmation or thank you message
        const transaction = orderData.purchase_units[0].payments.captures[0];
        setTransactionDetails({
          id: transaction.id,
          status: transaction.status,
          amount: transaction.amount.value,
          currency: transaction.amount.currency_code,
          orderID: data.orderID,
          payerInfo: orderData.payer,
        });

        setPaymentStatus("success");
        setMessage(`Transaction Successful`);
        console.log(
          "Capture result",
          orderData,
          JSON.stringify(orderData, null, 2)
        );
        getOrderStatusSuccess();
      }
    } catch (error) {
      console.error(error);
      setPaymentStatus("error");
      setMessage(`Sorry, your transaction could not be processed...${error}`);
      dispatch(setRazorpayModalError("network_issue"));
      //dispatch(setShowCancellationScreen(true))
    } finally {
      setIsProcessing(false);
      dispatch(setShowPayPalModal(false));
    }
  }

  async function handleOnCancel() {
    console.log("Payment cancelled");
    setPaymentStatus("cancelled");
    setMessage("");
    
  }
console.log('click' , clickedState)
  async function handleOnError(err) {
    console.error("Payment error:", err);
    setPaymentStatus("error");
    setMessage(`Error: ${err.message}`);
    dispatch(setRazorpayModalError("network_issue"));
    dispatch(setShowPayPalModal(false));
  }


  return (
    <div className="w-full">
      <div className="md:grid md:grid-cols-2 ">
        {/* Product details column */}
        <div
          className="rounded-xl w-full h-full px-4 py-6 md:mb-0"
          style={{
            background:
              "radial-gradient(53.11% 56.94% at 50% 50%, #244767 0%, #172C3F 100%)",
          }}
        >
          <div className="absolute top-8 right-3  flex items-center justify-end mb-3">
            <button
              onClick={handleClose}
              className="text-white md:text-black hover:text-gray-500 transition-colors"
            >
              <X size={24} />
            </button>
          </div>
          <div className="flex items-start justify-start w-full gap-4">
            <div className="h-[100px] w-[140px]">
              <img
                src={
                  "https://assets.learntube.ai/files/certifiedOptimisation/new%20cert%20(1).webp?updatedAt=1742193740469"
                }
                alt="h-full w-full"
              ></img>
            </div>
            <div className="flex flex-col justify-start h-full items-start">
              <div className="font-bold text-[20px] text-white">Your Cart</div>
              <div className="text-[12px] text-white/50 mt-2">
                Items In Cart: {getSelectedItems()?.length}
              </div>
              <div className="text-[12px] text-white/50 ">
                Total Price:{" "}
                <span className="font-semibold text-[16px] text-white relative">
                  ${discountPrice}
                  <div className="absolute -bottom-4 -right-2 w-[100px] h-[20px]">
                    <img src="https://assets.learntube.ai/files/Global/discount.png?updatedAt=1744103012812 w-full h-full"  ></img>
                  </div>
                </span>
               
              </div>
            </div>
            <div></div>
          </div>

          {products?.filter((item) => item?.type === 1)?.length > 0 && (
            <div className="flex flex-col mt-6">
              <div className="text-[14px] font-medium text-white">
                Instant Certificates
              </div>

              {products
                ?.filter((item) => item?.type === 1)
                ?.map((product, index) => (
                  <div className="mt-2 flex flex-row justify-between items-center">
                    <div className="text-[12px] font-medium text-white/70 w-[80%] line-clamp-1">
                      {product?.product_name}
                    </div>
                    <div className="flex flex-row items-center gap-1 justify-center">
                      <div className="text-[10px] line-through text-[#FF4646]">
                        ${product?.product_original_price}
                      </div>
                      <div className="text-[12px]  text-white">
                        ${product?.product_price}
                      </div>
                    </div>
                  </div>
                ))}
              <div className="w-full border-white/50 border-[1px] mt-4 border-dotted "></div>
            </div>
          )}

          {products?.filter((item) => item?.type === 2)?.length > 0 && (
            <div className="flex flex-col mt-6">
              <div className="text-[14px] font-medium text-white">
                Certified Courses
              </div>

              {products
                ?.filter((item) => item?.type === 2)
                ?.map((product, index) => (
                  <div className="mt-2 flex flex-row justify-between items-center">
                    <div className="text-[12px] font-medium text-white/70 w-[80%] line-clamp-1">
                      {product?.product_name}
                    </div>
                    <div className="flex flex-row items-center gap-1 justify-center">
                      <div className="text-[10px] line-through text-[#FF4646]">
                        ${product?.product_original_price}
                      </div>
                      <div className="text-[12px] text-white">
                        ${product?.product_price}
                      </div>
                    </div>
                  </div>
                ))}
              <div className="w-full border-white/50 border-[1px] mt-4 border-dotted "></div>
            </div>
          )}

          {products?.filter((item) => item?.type === 3)?.length > 0 && (
            <div className="flex flex-col mt-6">
              {products
                ?.filter((item) => item?.type === 3)
                ?.map((product, index) => (
                  <div className=" flex flex-row justify-between items-center">
                    <div className="text-[14px] font-medium text-white/70 w-[80%] line-clamp-1">
                      {product?.product_name}
                    </div>
                    <div className="flex flex-row items-center gap-1 justify-center">
                      <div className="text-[10px] line-through text-[#FF4646]">
                        ${product?.product_original_price}
                      </div>
                      <div className="text-[12px] text-white">
                        ${product?.product_price}
                      </div>
                    </div>
                  </div>
                ))}
              <div className="w-full border-white/50 border-[1px] mt-4 border-dotted "></div>
            </div>
          )}

          {products?.filter((item) => item?.type === 4)?.length > 0 && (
            <div className="flex flex-col mt-6">
              {products
                ?.filter((item) => item?.type === 4)
                ?.map((product, index) => (
                  <div className=" flex flex-row justify-between items-center">
                    <div className="text-[14px] font-medium text-white/70 w-[80%] line-clamp-1">
                      {product?.product_name}
                    </div>
                    <div className="flex flex-row items-center gap-1 justify-center">
                      <div className="text-[10px] line-through text-[#FF4646]">
                        ${product?.product_original_price}
                      </div>
                      <div className="text-[12px] text-white">
                        ${product?.product_price}
                      </div>
                    </div>
                  </div>
                ))}
              <div className="w-full border-white/50 border-[1px] mt-4 border-dotted "></div>
            </div>
          )}

          <div className="flex justify-between items-center mt-4 lg:mb-6">
            <span className="font-semibold text-[18px] text-white">
              Total Price:
            </span>
            <div className="flex flex-row items-center gap-1 justify-center">
              <div className="text-[12px] line-through text-[#FF4646]">
                ${originalPrice}
              </div>
              <div className="text-[18px] font-bold text-[#2BBD13]">
                ${discountPrice}
              </div>
            </div>
          </div>
        </div>

        {/* Payment column */}
        <div className={`md:border-l shadow-xl ${clickedState ? 'bg-white'  : 'bg-[#26588B]'}  md:bg-white md:rounded-r-xl px-4 py-4 md:py-6 md:pl-8 lg:pl-10 md:max-h-600 lg:max-h-700 md:overflow-y-scroll`}>
          <h2 className="font-medium text-center text-[14px] md:text-black text-white md:text-xl lg:text-2xl mb-2 lg:mb-6">
            Choose A Payment Method
          </h2>

          {message && (
            <div
              className={`mb-4 p-3 rounded text-sm ${
                message.includes("Error") ||
                message.includes("Sorry") ||
                message.includes("Could not")
                  ? "bg-red-50 text-red-700"
                  : "bg-blue-50 text-blue-700"
              }`}
            >
              {message}
            </div>
          )}
          {
            <PayPalScriptProvider
              options={{
                "client-id": "AWkVsYsGC2Px9AOWaPndTn3FEA0WSEsfPhTtb3YkjGFq3LE4zCWrXvj960JEGlNb6g4p0DArnHek0vky", // Replace with your PayPal client ID in production
                currency: "USD",
                intent: "capture",
                
              }}
            >
              <PayPalButtons
                fundingSource={FUNDING.PAYPAL}
                style={{
                  layout: "vertical",
                  color: "gold", // Options: gold, blue, silver, white, black
                  shape: "rect",
                  height: 48,
                  label: "pay", // Options: paypal, checkout, buynow, pay
                }}
                disabled={isProcessing}
                createOrder={handleCreateOrder}
                onApprove={handleOnApprove}
                onError={handleOnError}
                onCancel={handleOnCancel}
              />

              {/* Credit/Debit Card Button */}
              <PayPalButtons
                fundingSource={FUNDING.CARD}
                style={{
                  layout: "vertical",
                  color: "white", // Different color for card button
                  shape: "rect",
                  height: 48,
                  label: "pay", // "pay" is a good option for the card button
                }}
                disabled={isProcessing}
                createOrder={handleCreateOrder}
                onApprove={handleOnApprove}
                onError={handleOnError}
                onCancel={(e)=>{setClickedState(false); handleOnCancel()}}
                onClick={(e)=> setClickedState(true)}
              />
            </PayPalScriptProvider>
          }

          {/* {paymentStatus === "success" && transactionDetails && (
            <div className="mt-4 lg:mt-6 p-4 bg-green-50 text-green-700 rounded">
              <p className="font-bold text-lg mb-2 text-center">Payment Successful!</p>
              <p className="mb-2">Transaction ID: {transactionDetails.id}</p>
              <p className="mb-2">Status: {transactionDetails.status}</p>
              <p className="mb-2">Amount: {transactionDetails.currency} {transactionDetails.amount}</p>
              <p className="mb-2">Order ID: {transactionDetails.orderID}</p>
              <p className="text-sm mt-4">You'll receive access to your digital product shortly.</p>
              <button 
                onClick={resetPayment}
                className="w-full mt-4 bg-green-600 text-white py-2 rounded hover:bg-green-700"
              >
                Make Another Purchase
              </button>
            </div>
          )}
          
          {paymentStatus === "error" && (
            <div className="mt-4 lg:mt-6 p-4 bg-red-50 text-red-700 rounded">
              <p className="font-bold text-lg mb-2 text-center">Payment Error</p>
              <p className="mb-4">There was an error processing your payment. Please try again.</p>
              <button 
                onClick={resetPayment}
                className="w-full bg-red-600 text-white py-2 rounded hover:bg-red-700"
              >
                Try Again
              </button>
            </div>
          )}
          
          {paymentStatus === "cancelled" && (
            <div className="mt-4 lg:mt-6 p-4 bg-yellow-50 text-yellow-700 rounded">
              <p className="font-bold text-lg mb-2 text-center">Payment Cancelled</p>
              <p className="mb-4">You've cancelled the payment process. Your order has not been processed.</p>
              <button 
                onClick={resetPayment}
                className="w-full bg-yellow-600 text-white py-2 rounded hover:bg-yellow-700"
              >
                Try Again
              </button>
            </div>
          )}
           */}
          {isProcessing && (
            <div className="mt-4 text-center text-gray-600">
              <p>Processing your payment... Please wait.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
